import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button, Col, Modal, ModalHeader, ModalBody, Row } from "reactstrap";
import { UpdateOrganizationDetails } from "services/OrganizationServices";
import cross from "../../assets/images/icon/cross.svg";
const EditOrganizationModal = ({
  t,
  editOrgDetails,
  setEditOrgDetails,
  editModal,
  setEditModal,
  fetchData,
  ...props
}) => {
  const [errors, setErrors] = useState({});

  const toggleEditModal = () => {
    if (!!editModal) {
      setEditOrgDetails({});
    }

    setEditModal(!editModal);
    setErrors({});
  };

  const handleSaveClick = async () => {
    try {
      let errors = {};
      const nameRegex = /^[A-Za-z\s.]+$/;
      const addressRegex = /^[A-Za-z0-9\s\.,#\-]+$/;
  
      if (!editOrgDetails?.name?.trim()) {
        errors.name = t(`Organization.Name is required`);
      } else if (!nameRegex.test(editOrgDetails.name.trim())) {
        errors.name = t(`Organization.Name should contain only alphabets and spaces`);
      } else {
        errors.name = null;
      }
  
      if (!editOrgDetails?.address?.trim()) {
        errors.address = t(`Organization.Address is required`);
      } else if (!addressRegex.test(editOrgDetails.address.trim())) {
        errors.address = t(`Organization.Address should contain only alphanumeric characters`);
      } else {
        errors.address = null;
      }
  
      if (!!Object.values(errors).some(val => !!val)) {
        setErrors(errors);
  
        setTimeout(() => {
          setErrors({});
        }, 2500);
  
        return;
      }
  
      let reqBody = {
        name: editOrgDetails?.name?.trim(),
        address: editOrgDetails?.address?.trim(),
      };
  
      let response = await UpdateOrganizationDetails(editOrgDetails?.id, reqBody);
  
      let responseMsg = response?.data?.message || "Organization Updated Successfully";
  
      toast.success(responseMsg);
  
      setTimeout(() => {
        toggleEditModal();
        fetchData({});
      }, 1000);
    } catch (error) {
      let errMsg =
        error?.response?.data?.message ||
        error?.response?.message ||
        error?.message ||
        "Error while updating organization";
  
      let errors = error?.response?.data?.errors || {};
      setErrors(errors);
  
      setTimeout(() => {
        setErrors({});
      }, 2500);
  
      toast.error(errMsg);
    }
  };
  

  return (
    <>
      <div className="edit-modal">
        <Modal
          size="lg"
          isOpen={editModal}
          centered
          backdrop="static"
          toggle={toggleEditModal}
          className="edit-modal-card ediOrganizations"
        >
          {/* <ModalHeader tag="h4"></ModalHeader> */}

          <ModalBody>
            <div className="filters-cards-cross">
              <div className="filter-content">
                <h4>{t(`Organization.Update Organization Details`)}</h4>
              </div>
              <div className="filter-content cross">
                <img
                  src={cross}
                  alt=""
                  onClick={() => {
                    toggleEditModal();
                  }}
                />
              </div>
            </div>
            <Row className="">
              <Col md={12} className="">
                <Form.Group className="mb-2 floating-label">
                  <Form.Label className="float-label">
                    {t(`Organization.Name`)}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    placeholder={t(`Organization.Enter Name`)}
                    type="text"
                    name="name"
                    value={editOrgDetails?.name}
                    onChange={e => {
                      setEditOrgDetails({
                        ...editOrgDetails,
                        name: e.target.value,
                      });
                      setErrors({
                        ...errors,
                        name: !!e?.target?.value?.trim()
                          ? null
                          : t("Organization.Name is required"),
                      });

                      setTimeout(() => {
                        setErrors({
                          ...errors,
                          name: null,
                        });
                      }, 2500);
                    }}
                    title={t(`Organization.Name`)}
                  />
                  {errors?.name && (
                    <p className="text-danger">{errors?.name}</p>
                  )}
                </Form.Group>
              </Col>

              <Col md={12} className="mt-2">
                <Form.Group className="mb-2 floating-label">
                  <Form.Label className="float-label">
                    {t(`Organization.Address`)}
                  </Form.Label>
                  <Form.Control
                    rows="4"
                    as="textarea"
                    placeholder={t(`Organization.Enter Address`)}
                    name="address"
                    value={editOrgDetails?.address}
                    onChange={e => {
                      setEditOrgDetails({
                        ...editOrgDetails,
                        address: e.target.value,
                      });
                    }}
                    title={t(`Organization.Address`)}
                  />
                </Form.Group>
              </Col>

              <Col md={12} className="d-flex gap-2 mt-4">
                <button
                  className="btn btn-primary reset"
                  onClick={() => {
                    toggleEditModal();
                  }}
                >
                  {t(`Organization.Cancel`)}
                </button>
                <button
                  className="btn btn-primary search"
                  onClick={() => handleSaveClick()}
                >
                  {t(`Organization.Update`)}
                </button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default EditOrganizationModal;
